import { I18NProvider, LANGUAGES } from '@shared/utils'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Router } from '../routes'
import { StoreProvider } from '../store'
import { Login } from './routes'
import { GlobalHistory } from '../routes/globalHistory'
import Zoom from './routes/zoom/zoom'
import packageJson from '../../../../package.json'
import { HeroUIProvider } from "@heroui/react";

export const App = () => {
  if (document.querySelectorAll('meta[data-name="version"]').length === 0) {
    document.head.innerHTML+=`<meta data-name='version' content='${packageJson.version}'/>`
  }

  return (
    <HeroUIProvider className="h-full">
      <I18NProvider ns={['s-referent', 'analysis']} lang={LANGUAGES.es}>
        <BrowserRouter>
          <GlobalHistory />
          <StoreProvider apiURL={process.env.NX_SOCIAL_REFERENT_API_URL}>
            {({ user }) => (
              <Routes>
                <Route path="/auth/*">
                  <Route path="login" element={<Login />} />
                </Route>
                <Route path="/zoom/:page/:token" element={<Zoom />} />
                <Route path="/*" element={user && <Router user={user} />}></Route>
              </Routes>
            )}
          </StoreProvider>
        </BrowserRouter>
      </I18NProvider>
    </HeroUIProvider>
  )
}

export default App
